<template>
    <div class="dashboard-view">
        <past-due-error />
        <slot />
    </div>
</template>

<script>
import PastDueError from './Dashboard/PastDueError';

export default {
    components: { PastDueError },
};
</script>
